import _ from 'lodash';

export default function paths(obj, parentPath) {
  return _.flatten(
    _.keys(obj).map(key => {
      const path = parentPath ? parentPath + '.' + key : key;
      const stop = !_.isPlainObject(obj[key]) || _.isEmpty(obj[key]);
      return stop ? path : paths(obj[key], path);
    })
  );
}
